import React, { Component, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import PasswordInput from "src/shared/forms/inputs/PasswordInput";

export const PASSWORD = "password";
export const PASSWORD_CONFIRM = "passwordConfirm";

export const PASSWORD_LENGTH = 9;

export interface IResetPasswordFormData extends FormData {
  [PASSWORD]: string;
}

const ResetPasswordValidation = (value: any): ReactNode | void => {
  if (typeof value !== "string") {
    return;
  }

  // Check length
  if (value.length < PASSWORD_LENGTH) {
    return (
      <FormattedMessage id="authentication.forget.reset.validations.password.complexity" />
    );
  }

  // Check lowercase.
  if (!/[a-z]+/g.exec(value)) {
    return (
      <FormattedMessage id="authentication.forget.reset.validations.password.complexity" />
    );
  }

  // Check uppercase.
  if (!/[A-Z]+/g.exec(value)) {
    return (
      <FormattedMessage id="authentication.forget.reset.validations.password.complexity" />
    );
  }

  // Check special characters.
  if (!/[@$!%*?&]+/g.exec(value)) {
    return (
      <FormattedMessage id="authentication.forget.reset.validations.password.complexity" />
    );
  }
};

const ResetPasswordConfirmationValidation = (
  value: any,
  allValues: IResetPasswordFormData,
): ReactNode | void => {
  if (!value) {
    return;
  }

  const password: string = allValues[PASSWORD];
  if (!password) {
    return (
      <FormattedMessage id="authentication.forget.reset.validations.password.confirm.not_match" />
    );
  }

  if (password !== value) {
    return (
      <FormattedMessage id="authentication.forget.reset.validations.password.confirm.not_match" />
    );
  }
};

export interface IResetPasswordFormProps {}

export default class ResetPasswordForm extends Component<IResetPasswordFormProps> {
  public render(): ReactNode {
    return (
      <>
        <PasswordInput
          inputID={PASSWORD}
          label={<FormattedMessage id="form.password" />}
          validations={ResetPasswordValidation}
        />

        <PasswordInput
          inputID={PASSWORD_CONFIRM}
          label={<FormattedMessage id="form.password.confirm" />}
          validations={ResetPasswordConfirmationValidation}
        />
      </>
    );
  }
}
